<template>
    <el-select
      v-model="caseWithClaimSelected"
      @change="handleChange"
      :placeholder="$t('casesAndClaims.placeholder.caseWithClaim')"
      :disabled="disabled"
  >
      <el-option
          v-for="option in caseWithClaim"
          :key="option.value"
          :label="option.label"
          :value="option.value"
      />
  </el-select>
</template>
<script>

export default {
  name: 'CaseWithClaimSelect',
  computed: {
    caseWithClaim() {
      if (this.defaultAll) {
        return [{ label: 'All', value: null },
          { label: 'Yes', value: true },
          { label: 'No', value: false }
        ];
      }
      return [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ];
    },
    caseWithClaimSelected: {
      get() {
        return this.value; // Obtiene el valor de la prop
      },
      set(newValue) {
        this.$emit('input', newValue); // Emite el nuevo valor al componente padre
      }
    }
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    defaultAll: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    reset() {
      this.caseWithClaimSelected = null;
      this.$emit('input', null);
      this.$emit('change', null);
    },
    handleChange(value) {
      this.$emit('change', value);
    }
  },

};
</script>
